"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOT_ENCODES_LIST = exports.REQUIRED_PARAM_KEYS = exports.ENV_PRO = exports.ENV_LIST = exports.METRIC_EVENT_PARAM_KEYS = exports.METRIC_PARAM_KEYS = exports.ACTION_TYPE_HEART = exports.SDK_VERSION = exports.DEFAULT_CODE = exports.METRIC_ACT = exports.LEGACY_ACT = exports.ACT = exports.PROJECT_ID = exports.APP_ID = exports.TRACKER_OPTIONS = exports.DOMAIN = exports.STORE_ID_KEY = exports.UID_KEY = exports.SESSION_ID_KEY = exports.HTTP_COOKIE_KEY = exports.PROD_ID = void 0;
var PROD_ID = 'shopline';
exports.PROD_ID = PROD_ID;
var HTTP_COOKIE_KEY = 'tracker_cid';
exports.HTTP_COOKIE_KEY = HTTP_COOKIE_KEY;
var SESSION_ID_KEY = 'tracker_sid';
exports.SESSION_ID_KEY = SESSION_ID_KEY;
var UID_KEY = 'osudb_uid';
exports.UID_KEY = UID_KEY;
var STORE_ID_KEY = 'store_id';
exports.STORE_ID_KEY = STORE_ID_KEY;
var DOMAIN = {
  PRODUCT: 'shop.eclytics.com',
  TEST: 'debug.eclytics.com'
};
exports.DOMAIN = DOMAIN;
var TRACKER_OPTIONS = {
  wait: 20,
  domain: DOMAIN.PRODUCT
};
exports.TRACKER_OPTIONS = TRACKER_OPTIONS;
var APP_ID = '101';
exports.APP_ID = APP_ID;
var PROJECT_ID = 'admintoC';
exports.PROJECT_ID = PROJECT_ID;
var ACT = 'webslcodetrack';
exports.ACT = ACT;
var LEGACY_ACT = 'websdkprotocol';
exports.LEGACY_ACT = LEGACY_ACT;
var METRIC_ACT = 'webmetricdata';
/**
 * 默认空值
 * 新协议规定要page、component、module、action_type，如果没有传则为默认空值
 */

exports.METRIC_ACT = METRIC_ACT;
var DEFAULT_CODE = '-999';
exports.DEFAULT_CODE = DEFAULT_CODE;
var SDK_VERSION = '1.3.3';
exports.SDK_VERSION = SDK_VERSION;
var ACTION_TYPE_HEART = '106';
exports.ACTION_TYPE_HEART = ACTION_TYPE_HEART;
var METRIC_PARAM_KEYS = ['app_id', 'version', 'project_id'];
exports.METRIC_PARAM_KEYS = METRIC_PARAM_KEYS;
var METRIC_EVENT_PARAM_KEYS = ['event_id', 'event_name', 'page', 'module', 'component', 'action_type', 'event_created_at_ms'];
exports.METRIC_EVENT_PARAM_KEYS = METRIC_EVENT_PARAM_KEYS;
var ENV_LIST = ['DEV', 'TEST', 'FAT', 'PRO'];
exports.ENV_LIST = ENV_LIST;
var ENV_PRO = 'PRO';
exports.ENV_PRO = ENV_PRO;
var REQUIRED_PARAM_KEYS = ['env'];
exports.REQUIRED_PARAM_KEYS = REQUIRED_PARAM_KEYS;
var NOT_ENCODES_LIST = ['device_token'];
exports.NOT_ENCODES_LIST = NOT_ENCODES_LIST;